import type { IControlSettingUI, IDependentControl } from '../../type';

import { TIME_OPTIONS } from '~/modules/report-analytic/constants/report-filter';
import { DIMENSION_INFO } from '../constants/dimension-info';
import { EDimensionKey, EReportControlId } from '../types';
import { EControlType } from '../../type';

export function getDimensionSettingUI(
  id: string,
  data: {
    label: string;
    value: EDimensionKey;
  },
  otherDependentControls?: IDependentControl[],
): IControlSettingUI {
  return {
    id,
    label: data.label,
    uid: id,
    type: EControlType.SELECT_BASE,
    defaultValue: data.value,
    dependentControls: [
      {
        id: EReportControlId.DIMENSIONS_FILTER,
      },
      ...(otherDependentControls || []),
    ],
    info: DIMENSION_INFO[id],
  };
}

export function getDTimeSettingUI(): IControlSettingUI {
  const id = EDimensionKey.TIME;
  return {
    id,
    uid: id,
    type: EControlType.SELECT_DROPDOWN,
    options: TIME_OPTIONS,
    defaultValue: TIME_OPTIONS[0].value,
    dependentControls: [
      {
        id: EReportControlId.DIMENSIONS_FILTER,
      },
    ],
    info: DIMENSION_INFO[id],
  };
}
